import React from 'react';
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell, } from '@cargomatic/ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import formatMoney from 'utils/formatters/Money';
import ArrowTopRightOnSquareIcon from '../../../v2/icons/ArrowTopRightOnSquareIcon';
import SignedUrlButton from '../SignedUrlButton';
function CreditMemoTable({ creditMemoList = [] }) {
    const { t } = useTranslation();
    return (React.createElement("div", { "data-testid": "div-8769682e", className: "overflow-x-auto" },
        React.createElement(Table, { "data-testid": "table-632bdc93" },
            React.createElement(TableHeader, null,
                React.createElement(TableRow, { "data-testid": "tr-d08327ab" },
                    React.createElement(TableHead, null, t('NAME')),
                    React.createElement(TableHead, null, t('AMOUNT')),
                    React.createElement(TableHead, null, t('DATE')),
                    React.createElement(TableHead, null, t('CREATED_BY')),
                    React.createElement(TableHead, null, t('PDF')))),
            React.createElement(TableBody, null, creditMemoList.map(({ number, amount_due: amountDue, timestamp: createdDate, created_by: createdBy, _id: id, currency, }) => {
                return (React.createElement(CreditMemoRow, { key: id, number: number, amountDue: amountDue, createdDate: createdDate, id: id, createdBy: createdBy, currency: currency }));
            })))));
}
const CreditMemoRow = ({ amountDue, createdBy, createdDate, id, number, currency, }) => {
    return (React.createElement(TableRow, { "data-testid": "tr-79b18f87" },
        React.createElement(TableCell, { "data-testid": "td-fef41e98" },
            React.createElement("div", { "data-testid": "div-e5068598", className: "flex justify-start items-center" },
                React.createElement("a", { "data-testid": "a-cf2a79dd", className: "flex justify-start items-center", target: "_blank", href: `/invoices/${id}`, rel: "noreferrer" },
                    number,
                    React.createElement(ArrowTopRightOnSquareIcon, { className: "ml-1 w-5 h-5" })))),
        React.createElement(TableCell, { "data-testid": "td-d88f99a9" },
            React.createElement("span", { "data-testid": "span-b1a39882" }, formatMoney(amountDue, currency))),
        React.createElement(TableCell, { "data-testid": "td-da7842ab" }, moment(createdDate).format('L')),
        React.createElement(TableCell, { "data-testid": "td-4b3b0b0d" }, createdBy),
        React.createElement(TableCell, { "data-testid": "td-4c264c54" },
            React.createElement(SignedUrlButton, { foreignKey: id, "data-testid": "CircleButton-f90285ab" }))));
};
export default CreditMemoTable;
